import React from 'react';
import { Row, Col } from 'antd';
import DualAxisChart from '../../../../../shared/charts/DualAxisChart';
import { summaryScale } from '../../utils/summaryScale';
import moment from 'moment-timezone';
import DetailBar from './components/DetailBar';
import SessionsTable from './components/SessionsTable';
import SessionDeviceBreakdown from './components/SessionDeviceBreakdown';
import { LoadingPage } from '../../../../../shared/LoadingPage';
import { useTimezone } from '../../../../../../core/hooks/useTimezone';

const SessionsTabView = ({
  reportDataSummary,
  campaignOrder,
  changeDatePicker,
  reportDataSummaryLoading,
}) => {
  const { timezone: effectiveTimezone = 'UTC' } = useTimezone();
  document.title = `${campaignOrder.name} - Sessions View`;

  const dropDownOptions = [
    { key: 'sessions', display: 'Sessions' },
    { key: 'pageViews', display: 'Page Views' },
  ];

  if (reportDataSummaryLoading) return <LoadingPage />;
  return (
    <>
      <DetailBar
        {...reportDataSummary}
        startDate={campaignOrder.startDate}
        endDate={campaignOrder.endDate}
      />
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <DualAxisChart
            byDate={reportDataSummary.byDate}
            xAxis="date"
            options={dropDownOptions}
            defaultLeftYValue={dropDownOptions[0]}
            defaultRightYValue={dropDownOptions[1]}
            customScale={summaryScale}
            onDatePickerChange={({ data, dates, rangeKey }) => {
              changeDatePicker(dates);
            }}
            disabled={!reportDataSummary.sessionList || reportDataSummary.sessionList.length === 0}
            has6MonDisables={false}
            allTimeDateRange={[
              effectiveTimezone === 'UTC'
                ? moment.utc(campaignOrder.startDate)
                : moment.tz(campaignOrder.startDate, effectiveTimezone),
              effectiveTimezone === 'UTC'
                ? moment.utc(campaignOrder.endDate)
                : moment.tz(campaignOrder.endDate, effectiveTimezone),
            ]}
          />
        </Col>
        <Col span={24}>
          <SessionDeviceBreakdown
            data={reportDataSummary ? reportDataSummary.deviceBreakdown : null}
          />
        </Col>
        <Col xs={24}>
          <SessionsTable data={reportDataSummary ? reportDataSummary.sessionList : []} />
        </Col>
      </Row>
    </>
  );
};

export default SessionsTabView;
